import React from 'react';
import { ForgotPassword } from '../../components/ForgotPassword';
import { PageMeta } from '../../components/PageMeta';
import './ForgotPasswordPage.scss';

export const ForgotPasswordPage: React.FC = () => {
  return (
    <>
      <PageMeta title="Forgot Password" />
      <div className="ForgotPasswordPage">
        <ForgotPassword fullPage />
      </div>
    </>
  );
};
